import { Checkbox, FormGroup } from "@mui/material";
import { GroupModel } from "features/admin/core/domain/group.model";
import { UserModel } from "features/admin/core/domain/user.model";
import { useCallback, useEffect, useState } from "react";

interface AdminEditUserPermissionProps {
  title: string;
  groupData:
    | GroupModel["stock_order"]
    | GroupModel["shop"]
    | GroupModel["sales"]
    | GroupModel["hubLink"];
  adminGroupState:
    | UserModel["groups"]
    | UserModel["stockOrderGroup"]
    | UserModel["stockOrderGroupSeller"]
    | UserModel["salesGroup"]
    | UserModel["hubLinkGroup"];
  property: string;
  setGroupPermissions: (perms: PermStateModel | null) => void;
}

export interface PermStateModel {
  [key: string]: Array<number> | null;
}

export function AdminEditUserPermission(props: AdminEditUserPermissionProps) {
  const { title, groupData, adminGroupState, property, setGroupPermissions } =
    props;

  const [permState, setPermState] = useState<PermStateModel | null>(null);

  useEffect(() => {
    if (permState === null) {
      let grps = adminGroupState.map((admnGrp) => admnGrp.id);
      setPermState({ ...(permState || {}), [property]: grps });
    }

    setGroupPermissions(permState ?? null);
  }, [permState]);

  const checkPermissions = useCallback(
    (id: number) =>
      permState?.[property]?.some((perms) => perms === id) ? true : false,
    [permState]
  );

  const handleOnChange = (e: { target: { checked: any } }, grpid: number) => {
    const checked = e.target.checked;

    if (checked) {
      setPermState({
        ...permState,
        [property]: [...(permState?.[property] || []), grpid],
      });
    } else {
      setPermState({
        ...permState,
        [property]: (permState?.[property] || []).filter((id) => id !== grpid),
      });
    }
  };

  return (
    <div className="flex flex-col text-Roboto">
      <FormGroup>
        <h2 className="text-xl">{title}</h2>

        <div className={`grid grid-flow-col grid-rows-4 gap-1`}>
          {groupData.map((grp) => (
            <div key={grp.id} className="flex items-center">
              <Checkbox
                checked={checkPermissions(grp.id)}
                onChange={(e) => handleOnChange(e, grp.id)}
              />
              <p>{grp.name}</p>
            </div>
          ))}
        </div>
      </FormGroup>
    </div>
  );
}
